import { Serializable, StarbaseFileModel } from 'starbase-launcher';
import { ImageType, ImageTypes } from './imageType';
import { Army } from './army';
import { ImageDate } from './imageDate';
import { KeywordLinking } from './keyword';
import { EditHistory } from './editHistory';
import { ImageIndividual } from './imageIndividual';
import { UnitLinking } from './unitLinking';
import { WeaponLinking } from './weaponLinking';
import { State } from './state';
import { LUSource } from './luSource';
import { WebApiService } from 'starbase-login';
import { BoundImageSet } from './boundImageSet';
import { CallNumberModel } from './callNumberModel';
import { QMManualLink } from './qmmanuallink';
import { BattleLink } from './battleLink';
import { PipeTransform, Pipe } from '@angular/core';
import { RelatedSetLinkingModel } from './relatedSetLinkingModel';
import { RelatedImageSetViewDataModel } from './relatedImageSetViewDataModel';
import { RelatedSetModel } from './relatedSetModel';

@Pipe({
  name: 'imageName'
})
export class ImageNamePipe implements PipeTransform {
  transform(name: string, orderNo: number): string {
    if (orderNo && orderNo > 0) {
      return 'Order No. ' + orderNo;
    } else {
      const dot = name.lastIndexOf('.');
      if (dot > 0) {
        switch (name.substr(dot)) {
          case '.jpg':
          case '.jpeg':
          case '.tif':
          case '.tiff':
          case '.png':
          case '.gif':
            return name.slice(0, dot);
          default:
            return name;
        }
      }
      return name;
    }
  }
}

/** Core class for 11th OVC Library System.
 * Contains all data or links to data regarding a particular image record.
 * Images can be an instance of most 'types' of presented information in the system
 * including Photos, Ordnance Returns, Letters, Quartermaster Manuals / Specifications
 * and others.*/
export class ImageFile extends StarbaseFileModel implements Serializable<ImageFile> {
  public name: string;
  public originalFileName: string;
  public year: number;
  public month: number;
  public day: number;
  public location: string;
  // public imageKeywords: Keyword[];
  public imageKeywords: KeywordLinking[];
  public notes: string;
  public filePath: string;
  public fileType: string;
  public war: string;
  public imageSetID: string;
  /** @deprecated Use Lookup Table 'battle` model and `battleLinks` instead */
  public battle: string;
  public battleLinks: BattleLink[];
  public armyId: number;
  public army: Army;
  public corps: number;
  public weapons: WeaponLinking[];
  // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/ban-types
  public portrait_Field: String | string;
  public mounted: boolean;
  public units: UnitLinking[];
  public thumbnailPath: string;
  public featured: boolean;
  public locationStateId: number;
  public locationState: State;
  public regionalName: string;
  public checkedOut: boolean;
  public fullyTagged: boolean;
  public batchNo: number;
  public initialUpload: Date;
  public typeOfImageId: ImageTypes;
  public typeOfImage: ImageType;
  public relevantDates: ImageDate[];
  public relatedImageSets: RelatedSetModel[];
  public relatedImageSetLinks: RelatedSetLinkingModel[];
  public editHistory: EditHistory[];
  public imageIndividuals: ImageIndividual[];
  public boundImageSets: BoundImageSet[] = [];
  public boundSetName: string;
  public hasBoundPages: boolean;
  public isBoundInnerPage: boolean;
  public quarterMasterManuals: QMManualLink[] = [];
  public sourceId: number;
  public source: LUSource;
  public callNo: string;
  public sourceCallNumber: CallNumberModel;
  public orderNo: number;
  public specialOrder: boolean;
  /** Primarily used on ImageTypes.Letter type data. */
  public transcription: string;
  public numericSortString: string;

  constructor() {
    super();
    this.filePath = '';
  }

  public get displayName(): string {
    if (this.orderNo && this.orderNo > 0) {
      return 'Order No. ' + this.orderNo;
    } else {
      return this.name;
    }
  }

  deserialize(input: any) {
    for (let d of input.relevantDates || []) {
      d = new ImageDate(d.month).deserialize(d);
    }
    return Object.assign(new ImageFile(), input);
  }

  public fixPathForDevServers(): void {
    this.filePath =
      (this.filePath.includes(WebApiService.GetAPIServerAddress()))
        ? this.filePath
        : WebApiService.GetAPIServerAddress() + '/' + this.filePath;
    this.filePath = this.filePath.replace('wwwroot/', '');
    this.thumbnailPath = this.thumbnailPath.replace('wwwroot/', ''); // fix for local dev server hosting
  }
}
